<template>
  <base-modal
    trigger-class-modal="modal-lg"
    trigger-class-content="flex-1 overflow-y-auto"
    trigger-class-footer="py-6 w-full flex justify-between"
    :show-modal="show"
    @close="doHideModal"
  >
    <div class="grid md:grid-cols-2">
      <contact-details />
      <legal-details class="mt-4 md:mt-0" :product-version="productVersion" />
    </div>

    <template #footer>
      <div class="w-full flex justify-end">
        <base-button class="btn-secondary" @click="doHideModal">
          {{ $t("Common.Button.close") }}
        </base-button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from "@/components/ui/BaseModal.vue";
import ContactDetails from "@/components/legal/ContactDetails.vue";
import LegalDetails from "@/components/legal/LegalDetails.vue";
import loadConfigData from "@/services/configJson.js";

export default {
  components: {
    BaseModal,
    ContactDetails,
    LegalDetails,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      buildVersion: "...",
      productVersion: "...",
    };
  },
  mounted() {
    loadConfigData().then((configData) => {
      this.buildVersion = configData.BuildVersion;
      this.productVersion = configData.ProductVersion;
    });
  },
  methods: {
    doHideModal() {
      this.$emit("close");
    },
  },
};
</script>
